<script>
import aliPayDialog from '../../../components/aliPayDialog.vue'
export default {
  components: { aliPayDialog },
  name: "smsConfig",
  data() {
    return {
      tableData: [],
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/ai/balance/record',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          { type: "select", field: "type", name: "记录类型", value: "", option: [{ label: '账户充值', value: 1 }, { label: '账户变更', value: 2 }] },
          { type: "datetime", field: "time", name: "发送时间", value: [] },
        ]
      },
      // 表头
      columns: [
        { prop: 'type', label: '类型' },
        { prop: 'remark', label: '描述', width: 740 },
        { prop: 'beforeBalance', label: '金额(元)' },
        { prop: 'afterBalance', label: '余额(元)' },
        { prop: 'created', label: '记录时间' },
      ],
      oCustomOptions: {
        // 请求的列表url
        url: '/api/v1/manage/ai/organization/balance',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: []
      },
      oColumns: [
        { prop: 'status', label: '账户状态', width: 130 },
        { prop: 'balance', label: '账户余额(元)' },
        { prop: 'updated', label: '最近一次操作' },
      ],
      show: false,
      settleType: "",
      switch1: true,
      switch2: false,
      loading: false,
      aiBalance: 0,
      drawerShow: false
    }
  },
  mounted() {
    this.getInitFn()
    this.getAIBalance()
  },
  methods: {
    AIRechargeClick(row) {
      this.$refs.aliPayDialog.rechargeOpen('AI_FEE', row.organizationId);
    },
    rechargeClick() {
      this.$refs.aliPayDialog.rechargeOpen('AI_FEE');
    },
    handleSwitchChange(switchNumber) {
      if (switchNumber === 1) {
        // 点了"平台支付"switch
        this.switch1 = true;
        this.switch2 = false;
        if (this.settleType !== 1) {
          this.show = true;
        }
      } else if (switchNumber === 2) {
        // 点了"机构支付"switch
        this.switch2 = true;
        this.switch1 = false;
        if (this.settleType !== 2) {
          this.show = true;
        }
      }
    },
    async getAIBalance() {
      let url = "/api/v1/manage/ai/count";
      let res = await this.$axios.get(url);
      if (res && res.code === 1) {
        this.aiBalance = res.data.balance;
      }
    },
    async getInitFn() {
      const url = "/api/v1/manage/ai/config"
      const { code, data } = await this.$axios.get(url)

      if (code === 1 && data) {
        this.settleType = data
        this.switch1 = data == 1
        this.switch2 = data == 2
      }
    },
    async onSubmit() {
      this.loading = true
      const url = "/api/v1/manage/ai/config"
      const { code } = await this.$axios.post(url, {
        settleType: this.settleType == 1 ? 2 : 1
      })
      this.loading = false
      if (code === 1) {
        this.$message.success('切换模式成功')
        this.$refs.oCustomTable.listFn()
        this.getAIBalance()
        this.handClose()
      }
    },
    paySuccess() {
      this.getAIBalance()
      this.$refs.oCustomTable.listFn()
    },
    handClose() {
      this.show = false;
      this.getInitFn()
    },
    recordShow(row) {
      this.customOptions.params.organizationId = row.organizationId;

      this.drawerShow = true;
      this.$nextTick(() => {
        this.$refs.customTable.listFn()
      })
    },
    handleClose() {
      this.drawerShow = false;
    }
  }
}
</script>

<template>
  <div class="smsConfig">
    <!-- 支付方式提示弹窗 -->
    <el-dialog :title="switch1 ? `平台支付` : '机构支付'" :before-close="handClose" :visible.sync="show"
      :close-on-click-modal="false" destroy-on-close width="420px">

      <div v-if="switch1">
        <div style="margin-bottom: 10px">开启平台支付后，我们将做如下账户变更</div>
        <div class="blueInfo">
          <p>1.各机构共用平台的AI识别余额</p>
          <p>2.各机构AI识别余额转入平台AI识别余额</p>
          <p>3.各机构AI识别余额将清零</p>
        </div>
      </div>
      <div v-else>
        <div style="margin-bottom: 10px">开启机构支付后，我们将做如下账户变更
        </div>
        <div class="blueInfo">
          <p>1.各机构自行充值AI识别余额</p>
          <p>2.平台已有余额默认归入总机构账户余额</p>
          <p>3.各机构AI识别余额置为0</p>


        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <custom-table :labelWidth="140" ref="oCustomTable" :customOptions="oCustomOptions" :columns="oColumns"
      has-organization="true" :refreshShow="false" :summaryList="[
        { name: 'balance', beforeUnit: '￥' },
      ]">
      <template slot="customTable-top">
        <div slot="customTable-top">

          <div class="flex-between">
            <div class="top-left">
              <div class="choose-item flex">
                <div>平台支付</div>
                <el-switch v-model="switch1" @change="handleSwitchChange(1)"
                  active-text="平台统一充值AI识别账户余额，下属机构使用识别功能时扣除平台识别账户余额"></el-switch>
              </div>

              <div class="choose-item flex">
                <div>机构支付</div>
                <el-switch v-model="switch2" @change="handleSwitchChange(2)"
                  active-text="机构自行充值AI识别账户余额，机构使用识别功能时扣除机构识别账户余额"></el-switch>
              </div>
            </div>
            <div class="top-right" v-if="settleType == 1">
              <img src="../../../assets/img/wenli.png" alt="">
              <div class="balance-box">
                <div class="balance flex-between">
                  <span>平台余额</span>
                  <span>
                    <span class="balance_num">{{ aiBalance }}</span>
                    <span class="balance_unit">元</span>
                  </span>
                </div>
                <div class="flex-between">
                  <div class="balance-tip">平台AI识别余额仅在“平台支付”模式下生效</div>
                  <div class="balance-btn" @click="rechargeClick">充值</div>
                </div>
              </div>
            </div>
          </div>

          <div class="blueInfo">
            <p>* 仅机构支付模式下，下方各机构的AI识别账户才可启用</p>
          </div>

        </div>
      </template>

      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'updated'">{{ row.updated | filterTime('YYYY-MM-DD HH:mm:SS') }}</template>
        <template v-else-if="item.prop === 'balance'"><span class="util-money">{{ row.balance || 0 }}</span></template>
        <template v-else-if="item.prop === 'status'">
          <el-tag size="small" :type="settleType == 2 ? 'success' : 'info'">{{ settleType == 2 ? '已启用' : '已停用' }}</el-tag>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>

      <template slot="table-operation">
        <el-table-column label="操作" width="150" fixed="right">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" @click="recordShow(row)">变更记录</el-button>
            <el-button type="text" v-if="settleType == 2" @click="AIRechargeClick(row)">充值</el-button>
          </div>
        </el-table-column>
      </template>
    </custom-table>


    <el-drawer :visible.sync="drawerShow" :before-close="handleClose" :destroy-on-close="true">
      <custom-table :labelWidth="140" ref="customTable" :customOptions="customOptions" :columns="columns">
        <template slot-scope="{item, row}">
          <template v-if="item.prop === 'created'">{{ row.created | filterTime('YYYY-MM-DD HH:mm:SS') }}</template>
          <template v-else-if="item.prop === 'type'">{{ row.type | filterConst('BALANCETYPE') }}</template>
          <template v-else-if="item.prop === 'beforeBalance'">{{ row.afterBalance - row.beforeBalance > 0 ?
            '+' + (row.afterBalance - row.beforeBalance).toFixed(2) : (row.afterBalance - row.beforeBalance).toFixed(2) }}</template>
          <template v-else-if="item.prop === 'afterBalance'">{{ row.afterBalance || 0 }}</template>
          <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
        </template>
      </custom-table>
    </el-drawer>

    <aliPayDialog ref="aliPayDialog" @success="paySuccess"></aliPayDialog>

  </div>
</template>

<style scoped lang="less">
.top-left {
  flex: 1;
  height: 127px;
  border-radius: 4px;
  border: 1px solid #0288FF15;
  padding: 24px 16px;
  box-sizing: border-box;

  .choose-item {
    padding: 10px;

    &>div:first-child {
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      margin-right: 16px;
    }
  }
}

.top-right {
  width: 384px;
  height: 127px;
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  padding: 24px 16px;
  box-sizing: border-box;
  position: relative;
  background: linear-gradient(90deg, #58B0FF 0%, #0288FF 100%);
  margin-left: 16px;
  color: #FFFFFF;

  img {
    width: 260px;
    height: 127px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }

  .balance-box {
    position: relative;
    z-index: 2;
  }

  .balance {
    font-weight: 500;
    font-size: 18px;

    .balance_num {
      font-size: 26px;
    }

    .balance_unit {
      font-size: 14px;
      margin-left: 4px;
    }
  }

  .balance-tip {
    font-weight: 400;
    font-size: 14px;
    font-family: SourceHanSansSC, SourceHanSansSC;
    margin-top: 12px;
    width: 200px;
  }

  .balance-btn {
    width: 44px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    border: 1px solid #FFFFFF;
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 400;
    font-size: 14px;
    margin-top: 24px;
    cursor: pointer;
  }
}

::v-deep .el-drawer {
  width: 80% !important;
  padding-top: 30px !important;

  .el-drawer__header {
    left: 4%;
    font-weight: bold;
  }
}
</style>